<template>
  <div class="page">
    <img src="../assets/404.jpg">
  </div>
</template>

<script>

export default {
  name: 'NotFound',
}
</script>


<style lang="scss" scoped >
.page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
</style>
